
import {Component, Vue, Prop, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";
import IComptage from "../../types/comptage.interface";
import SummarySection from "@/components/utils/SummarySection.vue";
import FiltersList from "@/components/comptage/FiltersList.vue";
import preferencesService from "@/services/preferences.service";
import frontService from "@/services/front.service";

const userModule = namespace("userModule");

@Component({
    components: {SummarySection, FiltersList}
})
export default class SidebarComptage extends Vue {
    dialogSavePreferences = false;
    dialogResetPreferences = false;

    @Prop() readonly result!: { nb: number; credits: number };
    @Prop() readonly filters;
    @Prop() readonly product: IComptage;

    @Prop() readonly unchanged: boolean;
    @Prop() readonly isCalculating: boolean;
    @Prop() readonly preferenceUpdate: boolean;
    @Prop() readonly dataTypes;

    @userModule.State
    public user!: any;

    interval = 0;
    displayNumber = 0;
    displayCredits = 0;
    isCounting = false;
    init = true;

    @Watch("result", {deep: true})
    changeDisplayNumber() {
        this.init = false;
        clearInterval(this.interval);
        if (this.result.nb === this.displayNumber && this.displayCredits === this.result.credits) {
            return;
        }
        if (isNaN(this.displayNumber)) {
            this.displayNumber = 0;
        }
        if (isNaN(this.displayCredits)) {
            this.displayCredits = 0;
        }
        this.isCounting = true;

        this.interval = window.setInterval(
            function () {
                if (this.displayNumber !== this.result.nb) {
                    let change = (this.result.nb - this.displayNumber) / 10;
                    change = change >= 0 ? Math.ceil(change) : Math.floor(change);
                    this.displayNumber = this.displayNumber + change;
                }
                if (this.displayCredits !== this.result.credits) {
                    let changeCredits = (this.result.credits - this.displayCredits) / 10;
                    changeCredits = changeCredits >= 0 ? Math.ceil(changeCredits) : Math.floor(changeCredits);
                    this.displayCredits = this.displayCredits + changeCredits;
                }
                if (this.displayCredits === this.result.credits && this.displayNumber == this.result.nb) {
                    this.isCounting = false;
                }
            }.bind(this),
            20
        );
    }

    savePreferenceFilter() {
        preferencesService.savePreferenceFilter(this.product, this.user.id, 'comptage').then(res => {
            this.$emit('save-preference', this.product.uuid !== null);
        });
    }

    formatNumber(x) {
        return frontService.numberWithSpaces(x);
    }
}
